import $ from 'jquery';
import config from '../../../config';

// Save Leave
export function get_leave_type( data ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'leave/',
			data: {
                method: 'GET_LEAVE_TYPE'
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_LEAVE_TYPE",
				leave: response
			})
		})

	}
}


export function save_leave( data ){
    return dispatch => {

        $.ajax({
			method: 'GET',
			url: config.apiurl + 'leave/',
			data: {
				method: 'SAVE_LEAVE',
				data: data
            }
		})
		.then(function (response) {
			dispatch({
				type: "SAVE_LEAVE",
				leave: response
			})
		})

    }
}

export function get_leave( user, filter ){
    return dispatch => {

        $.ajax({
			method: 'GET',
			url: config.apiurl + 'leave/',
			data: {
				method: 'GET_LEAVE',
				user: user,
				filter: filter
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_LEAVE",
				leave: response
			})
		})

    }
}

export function delete_leave( id ){
    return dispatch => {

        $.ajax({
			method: 'GET',
			url: config.apiurl + 'leave/',
			data: {
				method: 'DELETE_LEAVE',
				id: id
            }
		})
		.then(function (response) {
			dispatch({
				type: "DELETE_LEAVE",
				leave: response
			})
		})

    }
}


export function get_leave_by_id( id ){
    return dispatch => {

        $.ajax({
			method: 'GET',
			url: config.apiurl + 'leave/',
			data: {
				method: 'GET_LEAVE_BY_ID',
				id: id
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_LEAVE_BY_ID",
				leave: response
			})
		})

    }
}


export function update_leave( data ){
    return dispatch => {

        $.ajax({
			method: 'GET',
			url: config.apiurl + 'leave/',
			data: {
				method: 'UPDATE_LEAVE',
				data: data
            }
		})
		.then(function (response) {
			dispatch({
				type: "UPDATE_LEAVE",
				leave: response
			})
		})

    }
}

// Upload attachment
export function upload_files( data ){
	return dispatch => {
		
		$.ajax({
			method: 'POST',
			dataType : 'json',
			url: config.apiurl + 'leave/',
			data: data,
			processData: false,
			contentType: false
		}).then(function ( response ) {
			dispatch({
				type: "UPLOADED_ATTACHMENT",
				leave: response
			})
		})

	}

}

export function get_leave_company( id ){
    return dispatch => {

        $.ajax({
			method: 'GET',
			url: config.apiurl + 'leave/',
			data: {
				method: 'GET_LEAVE_COMPANY',
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_LEAVE_COMPANY",
				leave: response
			})
		})

    }
}


// WEBPACK FOOTER //
// ./src/pages/leave/actions/leave.action.js